import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import confetti from "canvas-confetti";
import { Star, Map, ChevronRight } from "lucide-react";
import { play } from "../../lib/audio";

export const RewardStep = ({ story, complete, onMap, onNext, mapLabel = "回地圖" }) => {
  const [res, setRes] = useState(null);
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    complete().then((r) => {
      setRes(r);
      confetti({ particleCount: 140, spread: 90, origin: { y: 0.6 }, colors: ["#C83E2B", "#FBBF24", "#2E7D32", "#ffffff"] });
      play("太棒了！你完成了" + story.story_title);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!res) return <div className="flex-1 flex items-center justify-center font-brush text-5xl text-[var(--vermilion)] floaty">小書童</div>;
  return (
    <div className="flex flex-col items-center justify-center gap-6 h-full text-center" data-testid="reward-step">
      <h1 className="font-brush text-6xl sm:text-7xl text-[var(--vermilion)]">太棒了！</h1>
      <div className="flex gap-3" data-testid="reward-stars">
        {[1, 2, 3].map((i) => (
          <motion.div key={i} initial={{ scale: 0, rotate: -180 }} animate={{ scale: 1, rotate: 0 }} transition={{ delay: 0.3 * i, type: "spring" }}>
            <Star size={84} className={i <= res.stars ? "text-amber-400 drop-shadow-lg" : "text-stone-200"} fill="currentColor" />
          </motion.div>
        ))}
      </div>
      <div className="flex flex-wrap justify-center gap-4">
        {res.new_badges.map((b, k) => (
          <motion.div key={b.id} initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 1 + k * 0.2 }} className="scroll-card px-6 py-4" data-testid={`reward-badge-${b.id}`}>
            <div className="text-5xl">{b.icon}</div>
            <div className="font-serif-tc text-xl font-bold mt-1">{b.name}</div>
          </motion.div>
        ))}
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.4, type: "spring" }} className="w-28 h-28 rounded-full bg-white border-4 border-dashed border-amber-300 flex items-center justify-center text-6xl rotate-[-8deg]" data-testid="reward-sticker">
          {res.sticker}
        </motion.div>
      </div>
      <div className="flex gap-4 mt-4">
        <button data-testid="reward-map-btn" onClick={onMap} className="kid-btn px-8 bg-white border-2 border-[var(--line)] text-xl font-serif-tc flex items-center gap-2"><Map /> {mapLabel}</button>
        {res.next_story && <button data-testid="reward-next-btn" onClick={() => onNext(res.next_story)} className="kid-btn px-8 bg-[var(--vermilion)] text-white text-xl font-serif-tc flex items-center gap-2">下一個故事 <ChevronRight /></button>}
      </div>
    </div>
  );
};
